/**
 * Formats a full name from first, middle, and last name parts.
 * Ensures consistent "First Middle Last" format throughout the application.
 * 
 * @param {string} firstName - The first name
 * @param {string} middleName - The middle name (optional)
 * @param {string} lastName - The last name
 * @returns {string} The formatted full name
 */
export const formatFullName = (firstName, middleName, lastName) => {
  return `${firstName || ''} ${middleName || ''} ${lastName || ''}`.replace(/\s+/g, ' ').trim();
};
